export default "__VITE_ASSET__DoOeYcJJ__"